import React from "react";
import {
    Dialog,
    DialogHeader,
    DialogContent,
    Flex,
    Inline,
    DialogActions,
    Button,
  } from "@airbus/components-react";

 /*****
 * 
 * MODAL Box Component
 */


  class ModalMessageBox extends React.Component {

    /*************/
    /*CONSTRUCTOR*/ 
    /*************/
    constructor(props) {
        super()
        //debugger;
        //title
        this.title = props.title;

        //Message
        this.message=props.message;

        //Description
        this.description = props.description;

        //default visibility
        this.open = props.open;

        //callback
        this.callback=props.onConfirmCallback;

        //on Cancel callback function
        this.onCancelCallback=props.onCancelCallback;
        
        //States
        this.state={
            open: this.open,            //on true open modal box
            processing: false,          //Request in progress
        }


    }

    componentDidMount() {

        //debugger;
    }


    componentDidUpdate(prevProps, prevState){
        //debugger;
        if ((JSON.stringify(this.props) !== JSON.stringify(prevProps)) || 
            (JSON.stringify(this.state) !== JSON.stringify(prevState)) 
        ) {
            
            this.title = this.props.title;

            //Message
            this.message=this.props.message;

            //Description
            this.description = this.props.description;

            //default visibility
            this.open = this.props.open !== prevProps.open ? this.props.open : this.state.open;

            //callback
            this.callback=this.props.onConfirmCallback;

            //on Cancel callback function
            this.onCancelCallback=this.props.onCancelCallback;

            //States
            //debugger;
            this.setState({
                open: this.open,          
                processing: this.state.processing
            })

        }
        
        

    }


    /*************/
    /*RENDERING*/ 
    /*************/
    render(){
        return(
            <div>
                <Dialog className={"modalBox"} open={this.state.open} onClose={this.onCancelCallback} >
                    <DialogHeader>{this.title}</DialogHeader>
                
                    <DialogContent >
                        <Flex style={{flexGrow:1, flexDirection: "row", paddingLeft: "1rem",verticalAlign: "top", marginTop: "50px"}}>
                            <Inline spacing="2-x" align="left" >
                                <div>{this.message}</div>
                            </Inline>
                        </Flex>
                        
                        {this.description !== undefined || this.description !== null ?
                        <Flex style={{flexGrow:1, flexDirection: "row", paddingLeft: "1rem",verticalAlign: "top", marginTop: "50px"}}>
                            <Inline spacing="2-x" align="left" >
                                <div>{this.description}</div>
                            </Inline>
                        </Flex>
                        :null}
                        
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.onUserCancel}>Annuler</Button>
                        <Button 
                            variant="primary" 
                            onClick={this.onUserConfirm}
                            disabled={this.state.processing}
                            >{!this.state.processing ? "Confirmer" : "En cours..." }</Button>
                    </DialogActions>
                
                </Dialog>
            </div>
        )}

  /**
   * On user confirm button
   */
  onUserConfirm= async () => {
    //debugger;
    this.setState({processing:true});
    await this.callback();
    this.setState({processing: false});
    
  }

  onUserCancel=() => {
    this.setState({processing: false});
    this.onCancelCallback();

  }
       

  }



  export default ModalMessageBox;
